import { TotalCoverageConfig } from '../interfaces/Types';

export const totalCoverageConfig: TotalCoverageConfig[] = [
  {
    product: 'home',
    totalCoverageInfo: [
      {
        packageCode: 'HOME_PACK_001',
        coverageLabel: 'Försäkringsbelopp',
        coverageAmount: 1500000,
        coverageCurrency: 'kr'
      },
      {
        packageCode: 'HOME_PACK_002',
        coverageLabel: 'Försäkringsbelopp',
        coverageAmount: 1000000,
        coverageCurrency: 'kr'
      },
      {
        packageCode: 'HOME_PACK_003',
        coverageLabel: 'Försäkringsbelopp',
        coverageAmount: 500000,
        coverageCurrency: 'kr'
      }
    ]
  }
];
